import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'app/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'app/components/ui/table';
import { useDashboardSlice } from '../../slice';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from 'app/components/ui/hover-card';
import { ArrowRight, Download } from 'lucide-react';
export function TopFileDownloads() {
  const { useGetTopFileDownloadsQuery } = useDashboardSlice();
  const [getList, { data: files, error, isLoading }] =
    useGetTopFileDownloadsQuery({});

  useEffect(() => {
    getList();
  }, []);

  return (
    <Card className=" bg-white  border-none  dark:bg-transparent rounded-xl overflow-hidden">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 py-3 bg-[#0E7490] text-white">
        <CardTitle className="text-md font-medium flex items-center gap-2">
          <Download className="w-4 h-4 text-white" />
          Top File Downloads
        </CardTitle>
        <Link
          to="/reports/download-history"
          className="text-xs  hover:underline uppercase flex items-center gap-1 text-white"
        >
          View All
          <ArrowRight className="w-4 h-4 text-white" />
        </Link>
      </CardHeader>
      <CardContent className="mt-4 overflow-x-auto max-h-[530px] overflow-y-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-gray-500 text-xs uppercase">
                Folder
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase">
                File Name
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase">
                Downloads
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {files?.data?.length ? (
              files.data.map(file => (
                <TableRow key={file.file_id} className="hover:bg-gray-50">
                  <TableCell className="text-gray-700">
                    <HoverCard>
                      <HoverCardTrigger className="max-w-[200px] overflow-hidden whitespace-nowrap block">
                        {file?.parent_folder}
                      </HoverCardTrigger>
                      <HoverCardContent>{file?.parent_folder}</HoverCardContent>
                    </HoverCard>
                  </TableCell>
                  <TableCell className="text-gray-700">
                    <HoverCard>
                      <HoverCardTrigger className="max-w-[200px] overflow-hidden whitespace-nowrap block">
                        {file?.file}
                      </HoverCardTrigger>
                      <HoverCardContent>{file?.file}</HoverCardContent>
                    </HoverCard>
                  </TableCell>
                  <TableCell className="text-gray-700">
                    {file?.downloads}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={4}
                  className="text-center text-gray-400 py-8"
                >
                  No top file downloads found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
